import React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import Button from 'components/Button'
import { NotifyProsOfOpenJobDialogViewModel } from './NotifyProsOfOpenJobViewModel'

interface NotifyProsOfOpenJobDialogProps {
  vm: NotifyProsOfOpenJobDialogViewModel
}

export default observer(function NotifyProsOfOpenJobDialog({
  vm,
}: NotifyProsOfOpenJobDialogProps) {
  return (
    <ModalSheet onRequestClose={vm.close} showing={vm.showing}>
      <ModalSheetHeader withCloseButton />

      <ModalSheetContentIllustration
        src={require('assets/images/img_chat.svg')}
        alt="Illustration of a hand holding a phone and reading a message"
      />

      <ModalSheetContent>
        <ModalSheetContentTitle>Notify Pros of open job</ModalSheetContentTitle>
        <ModalSheetContentDescription>
          Do you want to notify all available Pros?
        </ModalSheetContentDescription>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button type="default" onClick={vm.close}>
            Close
          </Button>
          <Button
            type="primary"
            onClick={vm.notifyProsOfOpenJob}
            loading={vm.notifyProsOfOpenJob.pending}
            data-test="notify-pros-of-open-job-button"
          >
            Notify Pros
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
